import {
  balanceAdjustDifferenceBalanceSchema,
  balanceAdjustIsDepositSchema,
  balanceAdjustReasonSchema,
} from '@/validations/balance-adjust';
import {
  number,
  object,
} from '@/validations/custom-yup';

/** 対象販売管理ID (加算時のみ必須) */
export const giftSalesManagementIdSchema = number()
  .label('対象販売管理')
  .when('isDeposit', {
    is: true,
    then: (it) => it.required(({ label }) => `${label}を選択してください。`),
    otherwise: (it) => it.notRequired(),
  });

/** 商品券残高調整フォームのバリデーション */
export const giftBalanceAdjustSchema = object({
  differenceBalance: balanceAdjustDifferenceBalanceSchema,
  isDeposit: balanceAdjustIsDepositSchema,
  reason: balanceAdjustReasonSchema,
  giftSalesManagementId: giftSalesManagementIdSchema,
});
